module.exports = __webpack_public_path__ + "static/media/c-programming.88eef2c4.png";